import getEnv from 'App/Root/getEnv'
import transports from './transports'

export default transports[getEnv()]
